import { DefaultItem } from '../types';

export default (item: unknown): item is DefaultItem => {
  return !!(item as DefaultItem).hidden;
};
